module.exports = __webpack_public_path__ + "static/media/20ECE3.3b2e2a01.jpg";